import { rest } from 'msw'

import { config } from '@percent/admin-dashboard/config'
import { mockOrganisation } from '@percent/admin-dashboard/fixtures/api/mockOrganisationResponse'
import { mockSuccessResponse } from '@percent/admin-dashboard/fixtures/api/mockSuccessResponse'
import { mockSewaOnboardingListResponse } from '@percent/admin-dashboard/fixtures/api/sewaOnboarding/mockSewaOnboardingListResponse'
import { mockSewaBankDetailsReviewListResponse } from '@percent/admin-dashboard/fixtures/api/sewaOnboarding/mockSewaBankDetailsReview'

export const sewaOrgListHandler = () =>
  rest.get(`${config.urls.api}v1/admin/organisations`, async (req, res, ctx) => {
    const ids = [...req.url.searchParams.getAll('organisationIds'), ...req.url.searchParams.getAll('organisationIds[]')]
    const orgs = ids.length
      ? ids.map((id, index) => ({
          ...mockOrganisation,
          id,
          name: `Sewa Org ${index + 1}`,
          countryCode: 'IND' as const
        }))
      : [mockOrganisation]

    return res(
      ctx.status(200),
      ctx.json({
        data: orgs,
        object: 'organisation_admin',
        totalResults: orgs.length,
        pageSize: orgs.length,
        _links: { current: 'https://staging-api.poweredbypercent.com/v1/admin/organisations' }
      })
    )
  })

export const sewaBankDetailsListHandler = () =>
  rest.get(`${config.urls.api}v1/admin/bank-details-reviews`, async (_, res, ctx) => {
    return res(ctx.status(200), ctx.json(mockSewaBankDetailsReviewListResponse))
  })

export const sewaOnboardingHandlers = [
  rest.get(`${config.urls.api}v1/admin/organisations/sewa-onboarding`, async (_, res, ctx) => {
    return res(ctx.status(200), ctx.json(mockSewaOnboardingListResponse))
  }),
  rest.post(`${config.urls.api}v1/admin/organisations/sewa-onboarding/:organisationId`, async (req, res, ctx) => {
    return res(ctx.status(200), ctx.json(mockSuccessResponse({ organisationId: req.params.organisationId })))
  }),
  rest.delete(`${config.urls.api}v1/admin/organisations/sewa-onboarding/:organisationId`, async (_, res, ctx) => {
    return res(ctx.status(204))
  })
]
